import React, {useEffect, useState} from "react";

/*
* просто враппер, пустышка.
* */
let Panel = (props) => {
    return (
        <div id={props.id}>
            {props.children}
        </div>
    )
}

export default Panel;